<template>
  <div class="overview">
    <CenterRoomsOverwiew />
  </div>
</template>

<script>
import CenterRoomsOverwiew from "@/components/components-salles/public/room/list/RoomsOverview.vue";

export default {
  name: "ViewCenterRooms",
  components: {
    CenterRoomsOverwiew,
  },
  computed: {},
};
</script>

<style lang="scss" scoped>
.overview {
  margin: 0 1rem;
  display: flex;
  justify-content: center;
  width: 100%;
}
</style>
